<template>
  <div class="service_assents">
    <nav-bar/>
    <search-bar/>
    <div class="main" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/me/myservice' }">服务订单</el-breadcrumb-item>
          <el-breadcrumb-item>待评价</el-breadcrumb-item>
          <el-breadcrumb-item>评价订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <!-- 订单信息 -->
        <div class="order_cell mb50">
          <p class="fz16 mb20">订单信息:</p>
          <div class="pay_table">
            <div class="tr fr">
              <div class="th fg fs">服务类型</div>
              <div class="th fg fs">服务工程师</div>
              <div class="th fg fs">服务距离</div>
              <div class="th fg fs">价格</div>
            </div>
            <div class="tr fr">
              <div class="td fg fs">
                <span>{{ order_detail.type_name }}</span>
              </div>
              <div class="td fg fs">
                <span>{{ order_detail.level_name }}</span>
              </div>
              <div class="td fg fs fr ac jc">
                <span>{{ order_detail.order_distance }}km</span>
              </div>
              <div class="td fg fs">
                <span>￥{{ order_detail.order_actual_price }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="fr ac mb20">
          <p class="fz14 black mr10">服务星级:</p>
          <el-rate
              v-model="assessment_star"
              :colors="['#458EF6','#458EF6','#458EF6','#458EF6','#458EF6']"
          ></el-rate>
        </div>
        <div class="fr afs mb20">
          <p class="fz14 black mr10">评价内容:</p>
          <el-input type="textarea" resize="none" v-model="assessment_desc" :rows="3"></el-input>
        </div>
        <!-- <div class="fr afs mb20">
            <p class="fz14 black mr10">评价图片:</p>
            <el-input type="textarea" resize="none" v-model="assessment_desc" :rows="3"></el-input>
        </div>-->
        <div class="fr ac jc">
          <el-button type="primary" @click="submit" size="small"
                     v-if="order_detail.technician_assign_state === '1' && order_detail.assessment_state === '0'">确认
          </el-button>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  props: {},
  data() {
    return {
      assessment_star: 0,
      assessment_desc: "",
      order_detail: {},
      loading: false
    };
  },
  computed: {},
  created() {
    this.getServiceOrderDetail();
  },
  mounted() {
  },
  watch: {},
  methods: {
    submit() {
      if (!this.assessment_star) {
        this.$message({
          message: "请选择评分",
          type: "warning"
        });
        return;
      }
      this.post("serviceInterfaces/v1.0/assessmentServiceOrder", {
        assessment_star: this.assessment_star,
        assessment_desc: this.assessment_desc,
        order_id: this.$route.query.id
      })
          .then(res => {
            this.$message({
              message: res.data,
              type: "success"
            })
            this.getServiceOrderDetail();
          })
    },
    // 订单详情
    getServiceOrderDetail() {
      this.post("serviceInterfaces/v1.0/getServiceOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        this.order_detail = res.data;
        this.loading = true;
      });
    }
  },
  components: {NavBar, SearchBar, FooterBar}
};
</script>

<style scoped lang="scss">
.service_assents {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;
      font-size: 14px;

      .order_cell {
        .order_cell_title {
          width: 130px;
          text-align: right;
        }

        .pay_table {
          width: calc(100% - 40px);
          margin: 0 20px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              height: 50px;
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              width: 25%;
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;
              // border-bottom: 1px solid #e5e5e5;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }

      .el-textarea {
        width: 40%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/serviceOrder/serviceassents.vue